import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';

import { AuthService, SocialUser } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';

import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { RegisterService } from '../../services/register.service';

import { GlobalService } from '../../services/global.service';
import { PlayerService } from '../../services/player.service';
import { VerifyEmailComponent } from '../verify-email/verify-email.component';
import { DialogService } from '../../services/dialog.service';
import { RegisterComponent } from '../register/register.component';

@Component({
    selector: 'sd-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.scss']
})


export class LoginDialogComponent implements OnInit {

    @ViewChild('regForm', { static: true }) regForm;
    externalRedirect = '';
    loginForm: UntypedFormGroup;
    registerForm: UntypedFormGroup;
    pwdHide: Boolean = true;
    loginType: Number = 1;
    isEmailExist: Boolean = false;
    registerError: Boolean = false;
    registerErrorMsg: String = '';
    loginError: Boolean = false;
    loginErrorMsg: String = '';
    loginLoading: Boolean = false;
    registerLoading: Boolean = false;
    buttonclicked: Boolean = false;
    buttonPressed: Boolean;
    socialLoading: Boolean = false;
    socialError: Boolean = false;
    socialErrorMsg: String = '';
    emailPopup: string;

    type = '';
    from = '';

    Loginsubmitted = false;
    Registersubmitted = false;

    verifyEmailDialogRef: MatDialogRef<VerifyEmailComponent>;
    registerDialogRef: MatDialogRef<RegisterComponent>;
    formStep = '';
    invalidEmailError: boolean = false;

    constructor(
        private matDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<LoginDialogComponent>,
        public dialog: DialogService,
        private authService: AuthService,
        public user: UserService,
        private api: ApiService,
        private register: RegisterService,
        private router: Router,
        public global: GlobalService,
        private player: PlayerService
    ) {
        // console.log(this.data);
        // console.log(this.router.url);


        this.loginType = (this.data.tab == 1 || this.data.tab == 2 || this.data.tab == 3) ? this.data.tab : 1;
        this.type = this.data.type;
        this.register.type = this.data.type;
        this.from = this.data.from;

        this.global.trackEvent('Login', ((this.loginType == 1) ? 'login' : 'register') + ' - ' + 'popup-open', this.from + '-' + this.type);

        this.global.gtmEvent(((this.loginType == 1) ? 'login' : 'register'), ((this.loginType == 1) ? 'login' : 'register') + '-popup-open', this.data.userLastClickLocation, this.data.userLastClickFrom);

        this.loginForm = new UntypedFormGroup({
            email: new UntypedFormControl('', [
                Validators.required,
                Validators.email,
                Validators.pattern(this.global.emailRegex)
            ]),
            pwd: new UntypedFormControl('', [
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(20)
            ])
        });

        this.registerForm = new UntypedFormGroup({
            emailR: new UntypedFormControl('', [
                Validators.required,
                Validators.email,
                Validators.pattern(this.global.emailRegex),
                this.emailExists.bind(this),
                this.invalidEmail.bind(this)
            ]),
            pwdR: new UntypedFormControl('', [
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(20)
            ])
        });
    }

    get email() { return this.loginForm.get('email'); }
    get pwd() { return this.loginForm.get('pwd'); }
    get emailR() { return this.registerForm.get('emailR'); }
    get pwdR() { return this.registerForm.get('pwdR'); }

    ngOnInit() {
        this.emailPopup = this.data['email']

    }

    activateLogin() {
        this.loginType = 1;
        //document.getElementById("navhighlight1").style.display="block";
        //document.getElementById("navhighlight2").style.display="none";
    }

    activateRegister() {
        this.loginType = 2;
        //document.getElementById("navhighlight1").style.display="none";
        //document.getElementById("navhighlight2").style.display="block";
    }

    onLoginFormSubmit() {
        this.Loginsubmitted = true;
        this.buttonclicked = true;

        if (this.loginForm.valid) {
            // console.log(this.loginForm.value);
            this.loginLoading = true;
            this.api.login(
                this.loginForm.value.email,
                this.loginForm.value.pwd
            ).subscribe(res => {
                this.buttonclicked = false;
                this.loginLoading = false;
                this.loginError = false;
                if (res.success) {
                    this.user.category = res.category;
                    this.user.token = 'Token ' + res.result.token;
                    this.user.id = res.result.id;
                    this.user.type = res.result.is_type;
                    this.user.slug = res.result.slug_username;
                    this.user.fname = res.result.profile.first_name;
                    this.user.lname = res.result.profile.last_name;
                    this.user.dp = res.result.profile.profile_pic;
                    this.user.cover = res.result.profile.cover_pic;
                    this.user.isProMember = res.result.is_pro;
                    this.user.expdays = res.result.sds_e;
                    this.user.iswhatsapp_verify = res.result.iswhatsapp_verify;
                    this.user.whatsapp_number = res.result.whatsapp_number;
                    this.user.isLabel = res.result.is_label;

                    this.user.genre = [];
                    res.result.genre_id.forEach(genre => {
                        this.user.genre.push(genre.name);
                    });


                    this.user.artistType = [];
                    res.result.artist_type.forEach(type => {
                        this.user.artistType.push(type.name);

                        if (type.name.toLowerCase() == 'band') {
                            this.user.type = 'Band';
                        }
                    });

                    this.user.mobile = res.result.mobile;
                    this.user.email = res.result.email;
                    this.user.isEmailVerified = res.result.ismail_verify;
                    this.user.isMobVerified = res.result.ismobile_verify;
                    this.user.songsCount = res.result.songs_count;
                    this.user.videosCount = res.result.videos_count;

                    this.user.isPwdSet = res.result.has_usable_password;

                    this.user.authorize_for_tv = res.result.authorize_for_tv;

                    if (this.user.type == 'Band') {
                        this.user.status = 2;
                    } else if (this.user.type == 'Artist') {
                        this.user.status = 1;
                    } else if (this.user.type == 'Listener') {
                        this.user.status = 3;
                    }


                    this.global.ga4Event('login', 'first_form_success', this.user.slug, 'manual', this.data.userLastClickFrom);

                    this.user.name = this.user.fname + ' ' + this.user.lname;

                    localStorage.setItem('category', JSON.stringify(this.user.category));
                    localStorage.setItem('token', JSON.stringify(this.user.token));
                    localStorage.setItem('id', JSON.stringify(this.user.id));
                    localStorage.setItem('type', JSON.stringify(this.user.type));
                    localStorage.setItem('slug', JSON.stringify(this.user.slug));
                    localStorage.setItem('fname', JSON.stringify(this.user.fname));
                    localStorage.setItem('lname', JSON.stringify(this.user.lname));
                    localStorage.setItem('dp', JSON.stringify(this.user.dp));
                    localStorage.setItem('cover', JSON.stringify(this.user.cover));
                    localStorage.setItem('genre', JSON.stringify(this.user.genre));
                    // localStorage.setItem('country', JSON.stringify(this.user.country));
                    // localStorage.setItem('state', JSON.stringify(this.user.state));
                    // localStorage.setItem('city', JSON.stringify(this.user.city));
                    localStorage.setItem('artistType', JSON.stringify(this.user.artistType));
                    localStorage.setItem('mobile', JSON.stringify(this.user.mobile));
                    localStorage.setItem('email', JSON.stringify(this.user.email));
                    localStorage.setItem('isEmailVerified', JSON.stringify(this.user.isEmailVerified));
                    localStorage.setItem('isMobVerified', JSON.stringify(this.user.isMobVerified));
                    localStorage.setItem('songsCount', JSON.stringify(this.user.songsCount));
                    localStorage.setItem('videosCount', JSON.stringify(this.user.videosCount));
                    localStorage.setItem('isPwdSet', JSON.stringify(this.user.isPwdSet));
                    localStorage.setItem('isProMember', JSON.stringify(this.user.isProMember));
                    localStorage.setItem('iswhatsapp_verify', JSON.stringify(this.user.iswhatsapp_verify));
                    localStorage.setItem('whatsapp_number', JSON.stringify(this.user.whatsapp_number));

                    this.screenGuides();


                    if (this.user.status == 1 || this.user.status == 2) {
                        this.global.activeNavTabs = 'dashboard';
                    } else {
                        this.global.activeNavTabs = '';
                    }

                    this.getAgreements();
                    this.landingPage();
                    this.closeDialog();
                    //console.log(res.result.artist_type.length, 'length')

                    if (this.user.status != 3 && res.result.artist_type.length < 1) {
                        this.formStep = '3';
                        this.openRegisterDialog();
                    } else if ((res.result.profile.country == null || res.result.profile.country == '')) {
                        this.formStep = '2';
                        this.openRegisterDialog();
                    } else if (!this.user.isEmailVerified) {
                        this.openVerifyEmailDialog(this.user.email);
                    }



                } else {
                    this.loginError = true;
                    this.global.ga4Event('login', 'error', '', 'manual', this.data.userLastClickFrom, 'error:first_form_success');

                    //this.loginErrorMsg = res.error;
                    //this.loginErrorMsg ="";

                }
            },
                (err: HttpErrorResponse) => {
                    this.loginLoading = false;
                    this.loginError = true;

                    if (err.error instanceof Error) {
                        this.loginErrorMsg = 'Client-side error occured!';
                        // console.log('Client-side error occured!');
                    } else {
                        this.loginErrorMsg = 'Server-side error occured!';
                        // console.log('Server-side error occured!');
                    }
                });
        }
    }
    
    resetEmailErrors() {
        this.invalidEmailError = false;
        this.isEmailExist = false; 
    }

    onRegisterFormSubmit() {
        this.Registersubmitted = true;
        if (this.registerForm.valid) {
            // console.log(this.registerForm.value);
            this.registerLoading = true;

            this.api.checkEmail(this.registerForm.value.emailR).subscribe(res => {
                this.registerLoading = false;
                this.registerError = false;

                // console.log(res.is_email_exists);

                if (res.is_email_exists) {
                    if(res.msg &&  res.msg == 'Invalid email address'){
                            this.invalidEmailError = true;
                            this.isEmailExist = false;
                            // console.log('Invalid email address');
                      }else{
                        this.invalidEmailError = false;
                        this.isEmailExist = true;
                      }
                    
                    if (this.global.isBrowser) {
                        const tempEmail = $('#emailR').val();
                        this.registerForm.patchValue({ emailR: '' });
                        $('#emailR').val('');
                        this.registerForm.patchValue({ emailR: tempEmail });
                        $('#emailR').val(tempEmail);
                    }
                    this.global.ga4Event('registration', 'error','', 'manual', this.data.userLastClickFrom, 'error:email already exist');
                } else {
                    this.isEmailExist = false;
                    this.register.register_from = 0;
                    this.register.from = this.router.url.split('?')[0];
                    this.register.email = this.registerForm.value.emailR;
                    this.register.password = this.registerForm.value.pwdR;

                    this.register.access_token = null;
                    this.register.provider = null;
                    this.register.update = null;

                    this.closeDialog();
                    this.openRegisterDialog();
                    this.global.ga4Event('registration', 'first_form_success', '', 'manual', this.data.userLastClickFrom);

                }
            },
                (err: HttpErrorResponse) => {
                    this.registerLoading = false;
                    this.registerError = true;

                    if (err.error instanceof Error) {
                        this.registerErrorMsg = 'Client-side error occured!';
                        // console.log('Client-side error occured!');
                    } else {
                        this.registerErrorMsg = 'Server-side error occured!';
                        // console.log('Server-side error occured!');
                    }
                });
        }
    }


    signInWithGoogle(): void {
        // console.log('GOOGLE SIGN IN');
        this.socialError = false;

        this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
            .then(response => {
                // console.log(response);

                this.socialLoading = true;

                this.api.sociaLogin(response.idToken, response.provider, this.from).subscribe(res => {
                    // console.log(res);
                    this.socialLoading = false;

                    if (res.success) {
                        this.socialError = false;

                        this.user.category = res.category;
                        this.user.token = 'Token ' + res.result.token;
                        this.user.id = res.result.id;
                        this.user.type = res.result.is_type;
                        this.user.slug = res.result.slug_username;
                        this.user.fname = res.result.profile.first_name;
                        this.user.lname = res.result.profile.last_name;
                        this.user.dp = res.result.profile.profile_pic;
                        this.user.cover = res.result.profile.cover_pic;
                        this.user.isProMember = res.result.is_pro;
                        this.user.isLabel = res.result.is_label

                        this.user.genre = [];
                        res.result.genre_id.forEach(genre => {
                            this.user.genre.push(genre.name);
                        });
                        /*
                        if ( res.result.country != null ) {
                            this.user.country = res.result.profile.country;
                        } else {
                            this.user.country = '';
                        }
    
                        if ( res.result.profile.state != null ) {
                            this.user.state = res.result.profile.city.state;
                        } else {
                            this.user.state = '';
                        }
    
                        if ( res.result.profile.city != null ) {
                            this.user.city = res.result.profile.city.name;
                        } else {
                            this.user.city = '';
                        }*/

                        this.user.artistType = [];
                        res.result.artist_type.forEach(type => {
                            this.user.artistType.push(type.name);

                            if (type.name.toLowerCase() == 'band') {
                                this.user.type = 'Band';
                            }
                        });

                        this.user.mobile = res.result.mobile;
                        this.user.email = res.result.email;
                        this.user.isEmailVerified = res.result.ismail_verify;
                        this.user.isMobVerified = res.result.ismobile_verify;
                        this.user.songsCount = res.result.songs_count;
                        this.user.videosCount = res.result.videos_count;
                        this.user.isPwdSet = res.result.has_usable_password;
                        this.user.iswhatsapp_verify = res.result.iswhatsapp_verify;
                        this.user.whatsapp_number = res.result.whatsapp_number;
    

                        this.user.authorize_for_tv = res.result.authorize_for_tv;

                        if (this.user.type == 'Band') {
                            this.user.status = 2;
                        } else if (this.user.type == 'Artist') {
                            this.user.status = 1;
                        } else if (this.user.type == 'Listener') {
                            this.user.status = 3;
                        }

                        this.user.name = this.user.fname + ' ' + this.user.lname;

                        localStorage.setItem('category', JSON.stringify(this.user.category));
                        localStorage.setItem('token', JSON.stringify(this.user.token));
                        localStorage.setItem('id', JSON.stringify(this.user.id));
                        localStorage.setItem('type', JSON.stringify(this.user.type));
                        localStorage.setItem('slug', JSON.stringify(this.user.slug));
                        localStorage.setItem('fname', JSON.stringify(this.user.fname));
                        localStorage.setItem('lname', JSON.stringify(this.user.lname));
                        localStorage.setItem('dp', JSON.stringify(this.user.dp));
                        localStorage.setItem('cover', JSON.stringify(this.user.cover));
                        localStorage.setItem('genre', JSON.stringify(this.user.genre));
                        /*
                        localStorage.setItem('country', JSON.stringify(this.user.country));
                        localStorage.setItem('state', JSON.stringify(this.user.state));
                        localStorage.setItem('city', JSON.stringify(this.user.city));
                        */
                        localStorage.setItem('artistType', JSON.stringify(this.user.artistType));
                        localStorage.setItem('mobile', JSON.stringify(this.user.mobile));
                        localStorage.setItem('email', JSON.stringify(this.user.email));
                        localStorage.setItem('isEmailVerified', JSON.stringify(this.user.isEmailVerified));
                        localStorage.setItem('isMobVerified', JSON.stringify(this.user.isMobVerified));
                        localStorage.setItem('songsCount', JSON.stringify(this.user.songsCount));
                        localStorage.setItem('videosCount', JSON.stringify(this.user.videosCount));
                        localStorage.setItem('isPwdSet', JSON.stringify(this.user.isPwdSet));
                        localStorage.setItem('isProMember', JSON.stringify(this.user.isProMember));
                        localStorage.setItem('iswhatsapp_verify', JSON.stringify(this.user.iswhatsapp_verify));
                        localStorage.setItem('whatsapp_number', JSON.stringify(this.user.whatsapp_number));

                        if (res.result.is_new_user) {
                            (<any>window).fbq('track', 'CompleteRegistration')
                            this.global.ga4Event('registration', 'first_form_success', this.user.slug, 'google', this.data.userLastClickFrom);


                        } else {
                            this.global.ga4Event('login', 'first_form_success', this.user.slug, 'google', this.data.userLastClickFrom);


                        }
                        this.closeDialog();
                        this.screenGuides();



                        if (this.user.status == 1 || this.user.status == 2) {
                            this.global.activeNavTabs = 'dashboard';
                        } else {
                            this.global.activeNavTabs = '';
                        }

                        if (res.result.is_new_user) {
                            this.register.register_from = 5;
                            this.register.from = this.router.url.split('?')[0];
                            this.register.email = this.user.email;
                            this.register.fname = this.user.fname;
                            this.register.lname = this.user.lname;
                            this.register.token = this.user.token;
                            this.register.username = this.user.slug;

                            this.register.access_token = response.idToken;
                            this.register.provider = response.provider;
                            this.register.update = true;


                            this.getAgreements();
                            this.landingPage();
                            if (res.result.is_type == 'Listener') {
                                this.dialog.openUpgradeAccountDialog('google-login')
                            }

                            if (res.result.artist_type.length < 1) {
                                this.formStep = '3';
                                this.openRegisterDialog();
                            } else if (res.result.profile.country == null || res.result.profile.country == '') {
                                this.formStep = '2';
                                this.openRegisterDialog();
                            } else if (!this.user.isEmailVerified) {
                                this.openVerifyEmailDialog(this.user.email);
                            }

                        } else {
                            this.getAgreements();

                            this.landingPage(res.result.is_new_user);

                            this.closeDialog();
                            if (res.result.artist_type.length < 1) {
                                this.formStep = '3';
                                this.openRegisterDialog();
                            } else if (res.result.profile.country == null || res.result.profile.country == '') {
                                this.formStep = '2';
                                this.openRegisterDialog();
                            } else if (!this.user.isEmailVerified) {
                                this.openVerifyEmailDialog(this.user.email);
                            }


                        }
                    } else {
                        this.socialError = true;
                        this.socialError = res.error;
                        this.global.ga4Event('login', 'error', this.user.slug, 'google', this.data.userLastClickFrom,'error:first_form_google');

                    }
                },
                    (err: HttpErrorResponse) => {
                        this.socialLoading = false;
                        this.socialError = true;

                        if (err.error instanceof Error) {
                            this.socialErrorMsg = 'Client-side error occured!';
                            // console.log('Client-side error occured!');
                        } else {
                            this.socialErrorMsg = 'Server-side error occured!';
                            // console.log('Server-side error occured!');
                        }
                    });
            })
      
    }

    signInWithFB(): void {
        // console.log('FACEBOOK SIGN IN');
        this.socialError = false;

        this.authService.signIn(FacebookLoginProvider.PROVIDER_ID)
            .then(response => {
                // alert(response);

                this.socialLoading = true;

                this.api.sociaLogin(response.authToken, response.provider, this.from).subscribe(res => {
                    // console.log(res);
                    this.socialLoading = false;

                    if (res.success) {
                        this.socialError = false;

                        this.user.category = res.category;
                        this.user.token = 'Token ' + res.result.token;
                        this.user.id = res.result.id;
                        this.user.type = res.result.is_type;
                        this.user.slug = res.result.slug_username;
                        this.user.fname = res.result.profile.first_name;
                        this.user.lname = res.result.profile.last_name;
                        this.user.dp = res.result.profile.profile_pic;
                        this.user.cover = res.result.profile.cover_pic;
                        this.user.isProMember = res.result.is_pro;
                        this.user.iswhatsapp_verify = res.result.iswhatsapp_verify;
                        this.user.whatsapp_number = res.result.whatsapp_number;
                        this.user.isLabel = res.result.is_label

    
                        this.user.genre = [];
                        res.result.genre_id.forEach(genre => {
                            this.user.genre.push(genre.name);
                        });
                        /*
                        if ( res.result.country != null ) {
                            this.user.country = res.result.profile.country;
                        } else {
                            this.user.country = '';
                        }
    
                        if ( res.result.profile.state != null ) {
                            this.user.state = res.result.profile.city.state;
                        } else {
                            this.user.state = '';
                        }
    
                        if ( res.result.profile.city != null ) {
                            this.user.city = res.result.profile.city.name;
                        } else {
                            this.user.city = '';
                        }*/

                        this.user.artistType = [];
                        res.result.artist_type.forEach(type => {
                            this.user.artistType.push(type.name);

                            if (type.name.toLowerCase() == 'band') {
                                this.user.type = 'Band';
                            }
                        });

                        this.user.mobile = res.result.mobile;
                        this.user.email = res.result.email;
                        this.user.isEmailVerified = res.result.ismail_verify;
                        this.user.isMobVerified = res.result.ismobile_verify;
                        this.user.songsCount = res.result.songs_count;
                        this.user.videosCount = res.result.videos_count;
                        this.user.isPwdSet = res.result.has_usable_password;

                        this.user.authorize_for_tv = res.result.authorize_for_tv;

                        if (this.user.type == 'Band') {
                            this.user.status = 2;
                        } else if (this.user.type == 'Artist') {
                            this.user.status = 1;
                        } else if (this.user.type == 'Listener') {
                            this.user.status = 3;
                        }

                        this.user.name = this.user.fname + ' ' + this.user.lname;

                        localStorage.setItem('category', JSON.stringify(this.user.category));
                        localStorage.setItem('token', JSON.stringify(this.user.token));
                        localStorage.setItem('id', JSON.stringify(this.user.id));
                        localStorage.setItem('type', JSON.stringify(this.user.type));
                        localStorage.setItem('slug', JSON.stringify(this.user.slug));
                        localStorage.setItem('fname', JSON.stringify(this.user.fname));
                        localStorage.setItem('lname', JSON.stringify(this.user.lname));
                        localStorage.setItem('dp', JSON.stringify(this.user.dp));
                        localStorage.setItem('cover', JSON.stringify(this.user.cover));
                        localStorage.setItem('genre', JSON.stringify(this.user.genre));
                        /*
                        localStorage.setItem('country', JSON.stringify(this.user.country));
                        localStorage.setItem('state', JSON.stringify(this.user.state));
                        localStorage.setItem('city', JSON.stringify(this.user.city));
                        */
                        localStorage.setItem('artistType', JSON.stringify(this.user.artistType));
                        localStorage.setItem('mobile', JSON.stringify(this.user.mobile));
                        localStorage.setItem('email', JSON.stringify(this.user.email));
                        localStorage.setItem('isEmailVerified', JSON.stringify(this.user.isEmailVerified));
                        localStorage.setItem('isMobVerified', JSON.stringify(this.user.isMobVerified));
                        localStorage.setItem('songsCount', JSON.stringify(this.user.songsCount));
                        localStorage.setItem('videosCount', JSON.stringify(this.user.videosCount));
                        localStorage.setItem('isPwdSet', JSON.stringify(this.user.isPwdSet));
                        localStorage.setItem('isProMember', JSON.stringify(this.user.isProMember));
                        localStorage.setItem('iswhatsapp_verify', JSON.stringify(this.user.iswhatsapp_verify));
                        localStorage.setItem('whatsapp_number', JSON.stringify(this.user.whatsapp_number));

                        if (res.result.is_new_user) {
                            (<any>window).fbq('track', 'CompleteRegistration')
                            this.global.ga4Event('registration', 'first_form_success', this.user.slug, 'facebook', this.data.userLastClickFrom);

                        } else {
                            this.global.ga4Event('login', 'first_form_success', this.user.slug, 'facebook', this.data.userLastClickFrom);
                            
                        }
                        this.closeDialog();
                        this.screenGuides();



                        if (this.user.status == 1 || this.user.status == 2) {
                            this.global.activeNavTabs = 'dashboard';
                        } else {
                            this.global.activeNavTabs = '';
                        }

                        if (res.result.is_new_user) {
                            this.register.register_from = 2;
                            this.register.from = this.router.url.split('?')[0];
                            this.register.email = this.user.email;
                            this.register.fname = this.user.fname;
                            this.register.lname = this.user.lname;
                            this.register.token = this.user.token;
                            this.register.username = this.user.slug;

                            this.register.access_token = response.authToken;
                            this.register.provider = response.provider;
                            this.register.update = true;

                            this.closeDialog();
                            /*this.router.navigate(['/register'], {
                                queryParamsHandling: 'merge'
                            });*/
                            this.openRegisterDialog();

                        } else {
                            this.getAgreements();

                            this.landingPage(res.result.is_new_user);

                            this.closeDialog();

                            if (!this.user.isEmailVerified) {
                                this.openVerifyEmailDialog(this.user.email);
                            }
                        }
                    } else {
                        this.socialError = true;
                        this.socialError = res.error;
                        this.global.ga4Event('login', 'error', this.user.slug, 'facebook', this.data.userLastClickFrom,'error:first_form_facebook');

                    }
                },
                    (err: HttpErrorResponse) => {
                        this.socialLoading = false;
                        this.socialError = true;

                        if (err.error instanceof Error) {
                            this.socialErrorMsg = 'Client-side error occured!';
                            // console.log('Client-side error occured!');
                        } else {
                            this.socialErrorMsg = 'Server-side error occured!';
                            // console.log('Server-side error occured!');
                        }
                    });
            })
            .catch(error => {
                // this.socialError = true;
                // this.socialErrorMsg = error;
                // alert(error);
                this.global.trackEvent('Registration', 'Register-Failure', 'Facebook Popup Error: ' + error);
                this.global.gtmEvent('registration', 'register-failure', 'Facebook Popup Error: ' + error, this.data.userLastClickFrom);
            });
    }


    closeDialog() {
        this.global.trackEvent('Login', 'Close', this.from + '-' + this.type);
        this.dialogRef.close('');
    }


    clickcloseDialog() {
        this.global.gtmEvent(((this.loginType == 1) ? 'login' : 'register'), 'click-close', ((this.loginType == 1) ? 'login' : 'register') + '-popup-close', this.data.userLastClickFrom);
        this.dialogRef.close('');
    }

    emailExists(control: AbstractControl): { [key: string]: boolean } | null {

        if (this.isEmailExist) {
            return { 'emailExists': true };
        }
        return null;
    }

    invalidEmail(control: AbstractControl): { [key: string]: boolean } | null {

        if (this.invalidEmailError) {
            return { 'invalidEmail': true };
        }
        return null;
    }

    screenGuides() {
        this.api.getScreenGuide('dashboard').subscribe(res => {
            // console.log(res);
            if (res.success) {
                this.global.guides.dashboard = res.is_dashboard_sg_read;
            }
        },
            (err: HttpErrorResponse) => {
            });

        this.api.getScreenGuide('claps').subscribe(res => {
            // console.log(res);
            if (res.success) {
                this.global.guides.claps = res.is_claps_sg_read;
            }
        },
            (err: HttpErrorResponse) => {
            });

        this.api.getScreenGuide('schedule').subscribe(res => {
            // console.log(res);
            if (res.success) {
                this.global.guides.schedule = res.is_schedule_sg_read;
            }
        },
            (err: HttpErrorResponse) => {
            });
    }

    /************** Landing Page Logic ***********/
    landingPage(is_new_user = false) {
        if (this.data.redirectTo != undefined && this.data.redirectTo != null && this.data.redirectTo != '' && this.data.redirectTo != '/') {
            if (this.data.type == 'opp' && this.data.from == 'apply' && !this.user.isEmailVerified) {

            } else {
                let redirectTo = this.data.redirectTo;

                if (this.data.type == 'pricing' && this.data.from == 'checkout') {
                    if (redirectTo == '/subscription/checkout' && this.user.isProMember == 1) {
                        redirectTo = '/mydashboard';
                    } else if (redirectTo == '/subscription/checkout/label' && this.user.isProMember ==1) {
                        redirectTo = '/mydashboard';
                    }
                }

                if (is_new_user) {
                    this.global.trackEvent('Registration', 'Success-landing-page', redirectTo);
                }

                this.router.navigate([redirectTo], { queryParams: { login: null }, queryParamsHandling: 'merge' });
            }
        } else {
            const activeRouterPath = this.router.url;

            if (
                (this.type != '' && this.type != undefined && this.type != null && this.type != 'sign-in' && this.type != 'register') ||
                (activeRouterPath.indexOf('opportunity') > -1 || activeRouterPath.indexOf('opportunities') > -1)
            ) {
                if (is_new_user) {
                    this.global.trackEvent('Registration', 'Success-landing-page', activeRouterPath);
                }



                this.global.reload();
            } else {
                if (this.user.type == 'Listener') {
                    if (is_new_user) {
                        this.global.trackEvent('Registration', 'Success-landing-page', '/songs');
                    }

                    this.router.navigate(['/songs']);
                } else {
                    if (is_new_user) {
                        this.global.trackEvent('Registration', 'Success-landing-page', '/mydashboard');
                    }

                    this.router.navigate(['/mydashboard']);
                }
            }
        }
    }
    /************** /Landing Page Logic ***********/



    // clap(type, slug) {
    //     const angularThis = this;
    //     let activityId, clapsCount, totalClapsCount;

    //     if (type == 'song') {
    //         this.api.likeSong(slug, 'like', 1, activityId).subscribe(res => {
    //             activityId = res.id;
    //             clapsCount = res.user_like_count;
    //             totalClapsCount = res.total_like_count;

    //             if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
    //                 this.player.clapsCount = clapsCount;
    //                 this.player.totalClapsCount = totalClapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].clapsCount = clapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].totalClapsCount = totalClapsCount;
    //             }

    //             if (angularThis.global.isBrowser) {
    //                 $('.clapsCountTotal_' + slug).html(totalClapsCount.toString());
    //             }
    //         },
    //             (err: HttpErrorResponse) => {
    //             });
    //     } else if (type == 'album') {
    //         this.api.likeAlbum(slug, 'like', 1, activityId).subscribe(res => {
    //             activityId = res.id;
    //             clapsCount = res.user_like_count;
    //             totalClapsCount = res.total_like_count;

    //             if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
    //                 this.player.clapsCount = clapsCount;
    //                 this.player.totalClapsCount = totalClapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].clapsCount = clapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].totalClapsCount = totalClapsCount;
    //             }

    //             if (angularThis.global.isBrowser) {
    //                 $('.clapsCountTotal_' + slug).html(totalClapsCount.toString());
    //             }
    //         },
    //             (err: HttpErrorResponse) => {
    //             });
    //     } else if (type == 'playlist') {
    //         this.api.likePlaylist(slug, 'like', 1, activityId).subscribe(res => {
    //             activityId = res.id;
    //             clapsCount = res.user_like_count;
    //             totalClapsCount = res.total_like_count;

    //             if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
    //                 this.player.clapsCount = clapsCount;
    //                 this.player.totalClapsCount = totalClapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].clapsCount = clapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].totalClapsCount = totalClapsCount;
    //             }

    //             if (angularThis.global.isBrowser) {
    //                 $('.clapsCountTotal_' + slug).html(totalClapsCount.toString());
    //             }
    //         },
    //             (err: HttpErrorResponse) => {
    //             });
    //     } else if (type == 'video') {
    //         this.api.likeVideo(slug, 'like', 1, activityId).subscribe(res => {
    //             activityId = res.id;
    //             clapsCount = res.user_like_count;
    //             totalClapsCount = res.total_like_count;

    //             if (this.from == 'player' && this.player.myPlaylist != undefined && this.player.myPlaylist != null) {
    //                 this.player.clapsCount = clapsCount;
    //                 this.player.totalClapsCount = totalClapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].clapsCount = clapsCount;
    //                 this.player.playlist[this.player.myPlaylist.current].totalClapsCount = totalClapsCount;
    //             }

    //             if (angularThis.global.isBrowser) {
    //                 $('.clapsCountTotal_' + slug).html(totalClapsCount.toString());
    //             }
    //         },
    //             (err: HttpErrorResponse) => {
    //             });
    //     }
    // }

    openVerifyEmailDialog(email) {
        const backdrop: any = true;
        const backdropClass: any = 'dialogBackdrop';
        const focus: any = false;
        const navigationClose: any = true;
        const disableClose: any = false;
        const maxWidth: any = 'calc(100% - 16px)';

        this.verifyEmailDialogRef = this.matDialog.open(VerifyEmailComponent, {
            data: { email: email },
            id: 'emailVerifyDialog',
            hasBackdrop: backdrop,
            backdropClass: backdropClass,
            autoFocus: focus,
            closeOnNavigation: navigationClose,
            disableClose: disableClose,
            maxWidth: maxWidth
        });
    }


    openRegisterDialog() {
        const backdrop: any = true;
        const backdropClass: any = 'dialogBackdrop';
        const focus: any = false;
        const navigationClose: any = true;
        const disableClose: any = true;
        const maxWidth: any = 'calc(100% - 16px)';
        const step: any = '';
        this.registerDialogRef = this.matDialog.open(RegisterComponent, {
            data: { formStep: this.formStep, userLastClickFrom: this.data.userLastClickFrom },
            id: 'emailVerifyDialog',
            hasBackdrop: backdrop,
            backdropClass: backdropClass,
            autoFocus: focus,
            closeOnNavigation: navigationClose,
            disableClose: disableClose,
            maxWidth: maxWidth,

        });
    }



    getAgreements() {
        this.api.getAgreements(0, 10).subscribe(res => {
            if (res.result.length > 0) {
                this.global.agreements = true;
            }
        },
            (err: HttpErrorResponse) => {
            });
    }





    toggle() {
        if (this.pwdHide) {
            this.pwdHide = false;
        } else {
            this.pwdHide = true;

        }

    }

}
